import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function VSLPainSection() {
  return <section className="w-full bg-[#0f0f0f] py-20 px-4 sm:px-6 lg:px-8 border-y border-white/5" data-id="element-2497">
      <div className="max-w-3xl mx-auto" data-id="element-2498">
        <div className="text-center mb-12" data-id="element-2499">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-2500">
            The MLS isn’t the problem. <br data-id="element-2501" />
            <span className="text-red-500" data-id="element-2502">Volume is.</span>
          </h2>
          <p className="text-xl text-[#b8bcc8] leading-relaxed" data-id="element-2503">
            You don't need better deals. You need more offers.
          </p>
        </div>

        <div className="bg-[#1a1a1a] rounded-2xl p-8 md:p-10 border border-white/5 shadow-2xl relative overflow-hidden" data-id="element-2504">
          {/* Red glow effect */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 blur-[80px] rounded-full pointer-events-none" data-id="element-2505" />

          <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-3" data-id="element-2506">
            <AlertTriangle className="text-red-500 w-6 h-6" data-id="element-2507" />
            If you are currently:
          </h3>

          <ul className="space-y-4 mb-10" data-id="element-2508">
            {['Manually writing offers one by one', 'Over-analyzing deals before making contact', 'Competing with wholesalers who move faster', 'Tired of inconsistent months and cash flow revenue'].map((item, index) => <li key={index} className="flex items-start gap-4 text-[#b8bcc8] text-lg" data-id="element-2509">
                <XCircle className="w-6 h-6 text-red-500/80 flex-shrink-0 mt-0.5" data-id="element-2510" />
                <span data-id="element-2511">{item}</span>
              </li>)}
          </ul>

          <div className="text-center pt-6 border-t border-white/10" data-id="element-2512">
            <p className="text-white font-medium text-lg mb-2" data-id="element-2513">
              Stop playing small.
            </p>
            <a href="#book" className="text-[#3ab795] font-bold hover:underline text-lg inline-flex items-center gap-1" data-id="element-2514">
              Let's fix your volume problem
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2515">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" data-id="element-2516" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>;
}